import { getApiClient } from '@apps/web/lib/api_client';
import { useApiQuery } from '@apps/web/swr_data_fetching/use_api_query';

// Server-derived checklist progress: the GET unions usage-derived completion
// (the member actually ran the tool) with the steps stored from "Try in chat".
//
// `enabled` is the load switch, not just a render hint: this widget sits in the
// sidebar of every page, and the GET derives completion from run history. An
// org that will never show the checklist must never issue the request.
export function useAgentChecklist(
    organizationId: string | null,
    {
        enabled,
        reason,
    }: { readonly enabled: boolean; readonly reason?: string },
) {
    return useApiQuery({
        path: '/organizations/{organization_id}/agent-checklist',
        method: 'get',
        pathParams: organizationId
            ? { organization_id: organizationId }
            : undefined,
        enabled: enabled && !!organizationId,
        select: (response) => response,
        reason,
    });
}

// Returns the stored state the write produced. The caller uses it instead of
// re-running the GET, which would revert an optimistic tick when the write was
// a no-op (a platform admin has no profile row in an org they aren't in).
export async function completeAgentChecklistStep({
    organizationId,
    stepId,
}: {
    readonly organizationId: string;
    readonly stepId: string;
}) {
    return await getApiClient().post({
        url: '/organizations/{organization_id}/agent-checklist/complete',
        pathParams: { organization_id: organizationId },
        body: { step_id: stepId },
    });
}
